module.exports = __webpack_public_path__ + "static/CrossCountry-3a6b0e0a1443b732ea3d5e567fb696c3.jpg";